/* ============================================================
   Notre Chanson — main.js
   Shared UI behaviours: mobile menu toggle, promo bar helpers,
   and a lightweight scroll-reveal for below-the-fold sections
   (respects prefers-reduced-motion).
   ============================================================ */
(function () {
  'use strict';

  /* ---- Mobile slide-down menu ---- */
  var body = document.body;
  function openMenu()  { body.classList.add('nm-menu-open'); }
  function closeMenu() { body.classList.remove('nm-menu-open'); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-open]');
    if (t) { openMenu(); return; }
    if (e.target.closest('[data-menu-close]') || e.target.classList.contains('nm-mmenu-backdrop')) {
      closeMenu();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* ---- Scroll reveal ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
})();
